import { render, staticRenderFns } from "./cadfornecedores.vue?vue&type=template&id=77d74800&"
import script from "./cadfornecedores.vue?vue&type=script&lang=js&"
export * from "./cadfornecedores.vue?vue&type=script&lang=js&"
import style0 from "./cadfornecedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports